import React from "react";
import Plyr from "plyr-react";

function Player(props) {
  const videoSrc = {
    title: "Video",
    type: "video",

    sources: [
      {
        src: props.id,
        provider: "vimeo",
      },
    ],
  };

  const optionSrc = {
    options: [
      "play-large",
      "play",
      "progress",
      "current-time",
      "mute",
      "volume",
      "captions",
      "settings",
      "pip",
      "airplay",
      "fullscreen",
    ],
  };
  return (
    <div>
      <Plyr source={videoSrc} options={optionSrc} />
    </div>
  );
}

export default Player;
